function runPo2go(){
  var store_config = {
    "punchout_only":0,
    "transfer_label":"Transfer Cart",
    "custom_style":"body.punchout a.header__link.action-area__link {display: none} body.punchout button.btn.return_btn:nth-child(2) { display: none !important; } body.punchout button.shopify-payment-button__button.shopify-payment-button__button--unbranded.BUz42FHpSPncCPJ4Pr_f.jjzYeefyWpPZLH9pIgyw.RWJ0IfBjxIhflh4AIrUw { display: none; } body.punchout div#t4s-trust_seal23551ebc-3be1-40d6-81b2-30f03478cccb { display: none;} body.punchout button.t4s-btn__checkout.t4s-btn.t4s-btn-base.t4s-btn-style-default.t4s-btn-color-primary.t4s-btn-effect-default.t4s-w-100.t4s-justify-content-center.t4s-truncate { display:none;} body.punchout p.t4s-pr.t4s-d-block.t4s-cart__agree { display:none;} body.punchout input#cart_agree {display:none} body.punchout label {display:none}",
    "checkout_selector":"button[name=\"checkout\"]",
    "transfer_selector":"button[name=\"transfer_items\"]",
    "transfer_btn_html":"<button type=\"submit\" name=\"transfer_items\" class=\"button add_to_cart checkout\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",
    "return_selector": "header",
    "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\" >Close PunchOut<\/button>"
  };
   
    POExt = new Po2go_Shopify(store_config);     
    POSession = new Po2go({
        'account':'',
        'punchout_only' : store_config.punchout_only,
        'extension' : POExt
    });
    POSession.init();
    POSession.extension.setupPage();
    POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
}